// facebook icon component
export default function Facebook({ username = "" }) {
	return (
		<a
			href={`http://www.facebook.com/${username}`}
			className="text-gray-600 dark:text-gray-400 dark:hover:text-white dark:border-white dark:hover:border-primary flex h-10 w-10 items-center justify-center border border-gray-600 hover:border-primary hover:text-white hover:bg-primary transition-all duration-300 rounded-full">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				className="h-5 w-5"
				viewBox="0 0 32 32"
				fill="currentColor">
				<path d="M19 6h5v-6h-5c-3.86 0-7 3.14-7 7v3h-4v6h4v16h6v-16h5l1-6h-6v-3c0-0.542 0.458-1 1-1z" />
			</svg>
		</a>
	);
}
